import React from 'react';
import { ForgetPassword } from 'src/sections';

function ForgetpasswordPage() {
    return <ForgetPassword />;
}

export default ForgetpasswordPage;